import { MTextBlockBasicAlignment } from '../../molecules/MTextBlockBasic/MTextBlockBasic.types';
import { AEyebrowVariant } from '../../atoms/AEyebrow/index';
import { ASubheaderSize } from '../../atoms/ASubheader/ASubheader.types';
import { ABodyColor, ABodySize } from '../../atoms/ABody/ABody.types';
import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import { MTagType } from '../../molecules/MTag/index';
import { MButtonType, MButtonSize, MButtonIconPlacement } from '../../molecules/MButton/index';
import { AScrimGradientDirection } from '../../atoms/AScrimGradient/AScrimGradient.types';

export enum OCardLayeredStandardCTAStyle {
  Button = 'Button',
  Arrow = 'Arrow',
}

export enum OCardLayeredStandardAspectRatio {
  TALL_1_2 = '1:2',
  WIDE_3_2 = '3:2',
  TALL_2_3 = '2:3',
  TALL_9_16 = '9:16',
  SQUARE_1_1 = '1:1',
  WIDE_16_9 = '16:9',
}

export interface OCardLayeredStandardImageData {
  damPath?: string;
  assetPath?: string;
  altText?: string;
  dynamic?: boolean;
  enableSmartCrop?: boolean;
  renditions?: Array<{
    renditionPath: string;
    mediaValue: string;
    mediaQuery: string;
  }>;
  renditionUrl?: string | null;
}

export interface OCardLayeredStandardAImage {
  image?: OCardLayeredStandardImageData;
}

export interface OCardLayeredStandardAScrimGradient {
  direction?: AScrimGradientDirection;
  color?: string;
  opacity?: number;
}

export interface OCardLayeredStandardAEyebrow {
  eyebrowText?: string;
  eyebrowVariant?: AEyebrowVariant;
}

export interface OCardLayeredStandardASubheader {
  text?: string;
  size?: ASubheaderSize;
}

export interface OCardLayeredStandardABody {
  bodyText?: string;
  color?: ABodyColor;
  size?: ABodySize;
}

export interface OCardLayeredStandardMTextBlockBasic {
  alignment?: MTextBlockBasicAlignment;
  aEyebrow?: OCardLayeredStandardAEyebrow;
  aSubheader?: OCardLayeredStandardASubheader;
  aBody?: OCardLayeredStandardABody;
}

export interface OCardLayeredStandardAIcon {
  icon: string;
  size?: AIconSize;
}

export interface OCardLayeredStandardMTagALabel {
  text?: string;
  size?: 'XS' | 'M' | 'S';
}

export interface OCardLayeredStandardMTag {
  type?: MTagType;
  aLabel?: OCardLayeredStandardMTagALabel;
  aIcon?: OCardLayeredStandardAIcon;
}

export interface OCardLayeredStandardMButton {
  type?: MButtonType;
  size?: MButtonSize;
  buttonText?: string;
  icon?: MButtonIconPlacement;
  externalLink?: boolean;
}

export interface OCardLayeredStandardMButtonIcon {
  aIcon?: OCardLayeredStandardAIcon;
}

export type OCardLayeredStandardProps = {
  ctaLink?: string;
  aspectRatio?: OCardLayeredStandardAspectRatio;
  cTAStyle?: OCardLayeredStandardCTAStyle;
  aImage?: OCardLayeredStandardAImage;
  aScrimGradient?: OCardLayeredStandardAScrimGradient;
  mTextBlockBasic?: OCardLayeredStandardMTextBlockBasic;
  aIcon?: OCardLayeredStandardAIcon;
  mTag?: OCardLayeredStandardMTag;
  mButton?: OCardLayeredStandardMButton;
  mButtonIcon?: OCardLayeredStandardMButtonIcon;
  className?: string;
};
